import * as React from 'react'

import AltEnergyContent from './AltEnergyContent'
import AreasServed from './AreasServed'
import BulletsDark from './BulletsDark'
import BlockGroup from './BlockGroup'
import BlogList from './BlogList'
import CareersList from './careers/CareersList'
import CaseStudyContent from './case-studies/CaseStudyContent'
import CaseStudyResults from './case-studies/CaseStudyResults'
import CaseStudyList from './case-studies/CaseStudyList'
import CardList from './CardList'
import DescriptionColumns from './DescriptionColumns'
import EmailSignupForm from './EmailSignupForm'
import EmployeeList from './EmployeeList'
import ExpertiseList from './ExpertiseList'
import FeaturesWithIcons from 'components/common/FeaturesWithIcons'
import Hero from 'components/common/Hero'
import HeroHexPattern from 'components/template-expertise/HeroHexPattern'
import HeroBgImage from './hero/HeroBgImage'
import HeroChecklist from './hero/HeroChecklist'
import HeroDarkSimple from './hero/HeroDarkSimple'
import HeroGrayed from './hero/HeroGrayed'
import HeroLanding from './hero/HeroLanding'
import HeroPostcard from './hero/HeroPostcard'
import HeroQRCode from './hero/HeroQRCode'
import HeroSimple from './hero/HeroSimple'
import HeroSplit from './hero/HeroSplit'
import HeroTextStack from './hero/HeroTextStack'
import HeroVideo from './hero/HeroVideo'
import HVACContent from './HVACContent'
import IconList from './IconList'
import IconListDetailed from './IconListDetailed'
import ImageAndTextFeatured from './ImageAndTextFeatured'
import ImageAndTextSections from 'components/common/ImageAndTextSections'
import ImageAndTextSectionsCentered from 'components/common/ImageAndTextSectionsCentered'
import ImageGallery from './ImageGallery'
import IndustriesServed from './IndustriesServed'
import InteractiveMap from 'components/common/InteractiveMap'
import InternshipSteps from './careers/InternshipSteps'
import LinkedinCTA from './LinkedinCTA'
import LogoList from './LogoList'
import LogoListScroll from './LogoListScroll'
import Multicol from './Multicol'
import Partners from 'components/common/Partners'
import ProjectsList from 'components/common/ProjectsList'
import QRCodeList from './QRCodeList'
import RichtextModule from './RichtextModule'
import SafetyStats from 'components/common/SafetyStats'
import ServicesList from './ServicesList'
import SimpleTitle from './SimpleTitle'
import StatList from 'components/common/StatList'
import Testimonial from 'components/common/Testimonial'
import TextIconGrid from './TextIconGrid'
import TextWithBg from 'components/common/TextWithBg'
import TrustSection from './TrustSection'
import UVPList from './UVPList'
import VideoBlock from './video/VideoBlock'
import VideoLocal from './video/VideoLocal'
import WhySection from './WhySection'

export default function Blocks({ _type, ...props }) {
	switch (_type) {
		case 'altEnergyContent':
			return <AltEnergyContent {...props} />
		case 'areasServed':
			return <AreasServed {...props} />
		case 'bullets.dark':
			return <BulletsDark {...props} />
		case 'blockGroup':
			return <BlockGroup {...props} />
		case 'blog-list':
			return <BlogList {...props} />
		case 'careersList':
			return <CareersList {...props} />
		case 'caseStudyContent':
			return <CaseStudyContent {...props} />
		case 'caseStudyResults':
			return <CaseStudyResults {...props} />
		case 'case-study-list':
			return <CaseStudyList {...props} />
		case 'card-list':
			return <CardList {...props} />
		case 'descriptionColumns':
			return <DescriptionColumns {...props} />
		case 'email-signup-form':
			return <EmailSignupForm {...props} />
		case 'employeeList':
			return <EmployeeList {...props} />
		case 'expertiseList':
			return <ExpertiseList {...props} />
		case 'featuresWithIcons':
			return <FeaturesWithIcons {...props} />
		case 'hero':
			return <Hero {...props} />
		case 'heroBgImage':
			return <HeroBgImage {...props} />
		case 'hero.dark-simple':
			return <HeroDarkSimple {...props} />
		case 'hero.checklist':
			return <HeroChecklist {...props} />
		case 'heroGrayed':
			return <HeroGrayed {...props} />
		case 'hero.landing':
			return <HeroLanding {...props} />
		case 'hero.postcard':
			return <HeroPostcard {...props} />
		case 'hero.qr-code':
			return <HeroQRCode {...props} />
		case 'hero.split':
			return <HeroSplit {...props} />
		case 'heroSimple':
			return <HeroSimple {...props} />
		case 'hero.text-stack':
			return <HeroTextStack {...props} />
		case 'heroVideo':
			return <HeroVideo {...props} />
		case 'heroWithVideo':
			return <HeroHexPattern {...props} />
		case 'hvacContent':
			return <HVACContent {...props} />
		case 'iconList':
			return <IconList {...props} />
		case 'iconListDetailed':
			return <IconListDetailed {...props} />
		case 'imageAndTextCenteredSections':
			return <ImageAndTextSectionsCentered {...props} />
		case 'imageAndTextFeatured':
			return <ImageAndTextFeatured {...props} />
		case 'imageAndTextSections':
			return <ImageAndTextSections {...props} />
		case 'imageGallery':
			return <ImageGallery {...props} />
		case 'industriesServed':
			return <IndustriesServed {...props} />
		case 'interactiveMap':
			return <InteractiveMap {...props} />
		case 'internship-steps':
			return <InternshipSteps {...props} />
		case 'linkedin-cta':
			return <LinkedinCTA {...props} />
		case 'logo-list':
			return <LogoList {...props} />
		case 'logoListScroll':
			return <LogoListScroll {...props} />
		case 'multicol':
			return <Multicol {...props} />
		case 'partners':
			return <Partners {...props} />
		case 'projectList':
			return <ProjectsList {...props} />
		case 'qr-code.list':
			return <QRCodeList {...props} />
		case 'richtext-module':
			return <RichtextModule {...props} />
		case 'safetyStats':
			return <SafetyStats {...props} />
		case 'servicesList':
			return <ServicesList {...props} />
		case 'simpleTitle':
			return <SimpleTitle {...props} />
		case 'statList':
			return <StatList {...props} />
		case 'testimonial':
			return <Testimonial {...props} />
		case 'text-icon-grid':
			return <TextIconGrid {...props} />
		case 'textWithBg':
			return <TextWithBg {...props} />
		case 'trust-section':
			return <TrustSection {...props} />
		case 'uvp-list':
			return <UVPList {...props} />
		case 'video-block':
			return <VideoBlock {...props} />
		case 'videoLocal':
			return <VideoLocal {...props} />
		case 'whySection':
			return <WhySection {...props} />
		default:
			return <section data-type={_type} />
	}
}
